/** Lấy locale từ URL: /en/... hoặc /vi/... (không tính trailing slash) */
export function getLangFromPath(pathname = window.location.pathname) {
  const clean = (pathname || "").replace(/\/+$/, "") || "/";
  const seg = clean.split("/")[1];
  return seg === "vi" || seg === "en" ? seg : "en";
}

/** Bỏ prefix /en|/vi để so khớp route nội bộ (sidebar active, v.v.) */
export function stripLang(pathname = "") {
  const stripped = pathname.replace(/^\/(en|vi)(?=\/|$)/, "");
  if (stripped === "" || stripped === "/") return "/";
  // Bỏ trailing slash thừa: /installation/ → /installation
  return stripped.replace(/\/+$/, "") || "/";
}

/** Gắn locale vào path: "/installation" -> "/vi/installation" (home = "/vi", không "/vi/") */
export function withLang(path, lang = getLangFromPath()) {
  if (!path || path === "/") return `/${lang}`;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const noTrail = normalized.replace(/\/+$/, "") || "/";
  if (noTrail === "/") return `/${lang}`;
  return `/${lang}${noTrail}`;
}